import { SettingApi } from "lib/api";
import { ApiHelper, Http } from "lib/api/base";

import { Entry, Section } from "lib/data/model";


export class EntryApi {

	public static getEntries = async (): Promise<Entry[]> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Entry`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const entries: Entry[] = await ApiHelper.parseResponseBody(response);

				return entries;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return [];
	}

	public static getEntry = async (id: number, shouldTraverse: boolean = false): Promise<Entry | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Entry/${id}?shouldTraverse=${shouldTraverse}`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const entry: Entry = await ApiHelper.parseResponseBody(response);

				return entry;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static getHierarchy = async (id?: number): Promise<Section[][]> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl && id) {

			// Configure Url
			const url: string = `${baseUrl}/Entry/${id}/Hierarchy`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const hierarchies: Section[][] = await ApiHelper.parseResponseBody(response);

				return hierarchies;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return [];
	}

	public static saveEntry = async (entry: Entry): Promise<Entry | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			let url: string = `${baseUrl}/Entry`;

			// Initialize Response
			let response: Response;

			// Check For Empty ID
			if (entry.id) {

				// Update URL
				url += `/${entry.id}`;

				// Make Request
				response = await Http.httpPut(url, entry);
			}
			else {

				// Make Request
				response = await Http.httpPost(url, entry);
			}

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const saved: Entry = await ApiHelper.parseResponseBody(response);

				return saved;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}
}
